export {default} from './UserDetail';



// WEBPACK FOOTER //
// ./src/pages/UserDetail/index.ts